import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';

//constant
import { directUrl, homePageUrl } from '../../../helpers/Constants';

//assets
// import logo from "../../../assets/image/logo-black.webp";
import logo from "../../../assets/image/Logo3.svg";
import { userStore } from '../../../stores';
import { requestApi } from "../../../request-api";
import NotificationBadge from 'react-notification-badge';
import { Effect } from 'react-notification-badge';
function ComplianceOfficerHeader(props) {
	const location = useLocation();
	let myLocation = location.pathname;
	let navigate = useNavigate()
	let { hideHeader } = props;

	//states
	let [isOpen, setIsOpen] = useState(false);
	const [user, setUser] = useState({});
	const [notification, setNotification] = useState([]);
	//Mobile menu  

	const toggle = () => {
		setIsOpen(!isOpen)
	}

	const logout = () => {
		localStorage.clear()
		navigate(`${directUrl}sign-in`)
	}
	const directToSetting = () => {
		navigate(`${directUrl}auditor/create-user-profile/settings`)
	}

	useEffect(() => {
		userData()
		getNotification()
	}, []);

	const userData = () => {
		requestApi(`/superadmin/userData`, {
			method: "get",
		})
			.then((data) => {
				if (data.statusCode === 200) {
					setUser(data.data)

					console.log("local storage::", user.name)
				} else {
				}
			})
			.catch((error) => {
				console.log("Error", error);
			});
	};

	const seenStatusActivityLog = (e, activity_id) => {
		e.preventDefault()
		requestApi(`/activity/changeSeenStatus/${activity_id}`, {
			method: "get",
		})
			.then((data) => {

			})
			.catch((error) => {
				console.log("Error", error);
			})
	}


	const getNotification = () => {
		requestApi(`/activity/compliancer/notification`, {
			method: "get",
		})
			.then((data) => {
				if (data.statusCode === 200) {
					setNotification(data.data)
					console.log("local storage111::", data.data)
				} else {
				}
			})
			.catch((error) => {
				console.log("Error", error);
			});
	};

	const { pathname } = useLocation();
	return (
		<>
			
			{!hideHeader && (
				<header className='bs-head'>
					<Navbar expand="xl" light>
						<div className="container-fluid d-flex justify-content-between align-items-center px-4">
							<NavbarBrand href="">
								<img
									src={logo}
									alt="GLYPHER TECH LOGO"
									className='nav-logo'
								/>
							</NavbarBrand>

							<Nav className="me-auto d-flex" style={{ margin: "0 0 0 50px" }} navbar>
								<NavItem>
									{/* <NavLink
										className="px-3"
										exact
										to={`compliancer/dashboard`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('login') ? '#000' : '#555',
											fontWeight: myLocation.includes('login') ? 'bold' : 'normal',
										}}
									>
										Dashboard    
									</NavLink> */}
									<NavLink
																			className="	px-3"
																			to="/compliancer/dashboard"
																			style={{
																				textDecoration: "none",
																				color: pathname === "/compliancer/dashboard" ? "#000" : "#555",
																				fontWeight: pathname === "/compliancer/dashboard" ? "bold" : "normal",
																			}}
																		>
																			<i
																				className="icon-report"
																				style={{
																					color: pathname === "/compliancer/dashboard" ? "#000" : "#555",
																				}}
																			/>
																			Dashboard
																		</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className="px-3"
										exact
										to={`compliancer/compliencer-action`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('compliencer-action') ? '#000' : '#555',
											fontWeight: myLocation.includes('compliencer-action') ? 'bold' : 'normal',
										}}
									>
										Action
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className="px-3"
										exact
										to={`compliancer/reports`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('compliancer/reports') ? '#000' : '#555',
											fontWeight: myLocation.includes('compliancer/reports') ? 'bold' : 'normal',
										}}
									>
										Reports
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className="px-3"
										exact
										to={`compliancer/compliencer-comments`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('compliencer-comments') ? '#000' : '#555',
											fontWeight: myLocation.includes('compliencer-comments') ? 'bold' : 'normal',
										}}
									>
										Comments
									</NavLink>
								</NavItem>
							</Nav>

							<Nav className="align-items-center" navbar>
							
								<UncontrolledDropdown nav inNavbar>
									<DropdownToggle nav caret className="d-flex align-items-center">
										<img
											src="https://media.istockphoto.com/id/1223671392/vector/default-profile-picture-avatar-photo-placeholder-vector-illustration.jpg?s=612x612&w=0&k=20&c=s0aTdmT5aU6b8ot7VKm11DeID6NctRCpB755rA1BIP0="
											alt="User"
											style={{
												width: '32px',
												height: '32px',
												borderRadius: '50%',
												marginRight: '8px',
												objectFit: 'cover',
											}}
										/>
										<div className="d-none d-md-block text-start">
											<div style={{ fontWeight: 'bold', fontSize: '14px' }}>{user.name}</div>
											<div style={{ fontSize: '12px', color: '#777' }}>{user.email}</div>
										</div>
									</DropdownToggle>
									<DropdownMenu end>
										<DropdownItem disabled>Hi, {user.name}</DropdownItem>
										<DropdownItem divider />
										<DropdownItem onClick={logout}>Log Out</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown>
							</Nav>
						</div>
					</Navbar>
				</header>
			)}
		</>
	)
}

export default ComplianceOfficerHeader
